import TaxiCorporationFleetPartnerUpdateRequest, {
  TaxiCorporationFleetPartnerUpdateRequestBody,
} from "./taxi-corporation-fleet-partner-update.request";

const createBody = (
  request: TaxiCorporationFleetPartnerUpdateRequest,
): TaxiCorporationFleetPartnerUpdateRequestBody => {
  return {
    fleetPartnerId: request.fleetPartnerId,
    name: request.name,
    notes: request.notes,
  };
};

const taxiCorporationFleetPartnerUpdateRequestFactory = {
  createBody,
};

export default taxiCorporationFleetPartnerUpdateRequestFactory;
